 import axios, { AxiosResponse, AxiosError } from "axios";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const storedUserDetails = localStorage.getItem("userdetails");
const token = storedUserDetails ? JSON.parse(storedUserDetails).token.replace(/^"(.*)"$/, '$1') : null;

 export const getBilledClients = (
    _successCallBack: (response: any) => void,
    _errorCallBack: (errMessage: any) => void,
    ) => {
      const userDetailsFromStorage = JSON.parse(localStorage.getItem("userdetails") || "null");
    const headers = {
      Authorization: `Bearer ${userDetailsFromStorage.token}`, 
    };
    axios
      .get(`${global.api_url}/api/get_billed_to_clients?per_page_records&page_number&name&email&phone&zoho_customer_id&state`, {
        headers: headers,
      })
      .then((response: AxiosResponse) => {
        if (response.status === 200 || response.status === 201) {
          _successCallBack(response.data);
        } else {
          _errorCallBack("Unexpected status code: " + response.status);
        }
      })
      .catch((error: AxiosError) => {
          console.log('Error caught:', error);
          if (error.response?.status === 400) {
            _errorCallBack(error.response.data);
          } else if (error.response?.status === 404) {
              console.log(error.response.data);
            _errorCallBack(error.response.data);
          }else if (error.response?.status === 401) {
            localStorage.clear();
          } 
        });
  };
   export const getInvoices = (
    client_id: string,
    page_number: string,
    per_page_records: string,
    _successCallBack: (response: any) => void,
    _errorCallBack: (errMessage: any) => void,
    ) => {
      const userDetailsFromStorage = JSON.parse(localStorage.getItem("userdetails") || "null");
    const headers = {
      Authorization: `Bearer ${userDetailsFromStorage.token}`, 
    };
    axios
      .get(`${global.api_url}/api/get_billing_list?client_id=${client_id}&page_number=${page_number}&per_page_records=${per_page_records}`, {
      
        headers: headers,
      })
      .then((response: AxiosResponse) => {
        if (response.status === 200 || response.status === 201) {
          _successCallBack(response.data);
        } else {
          _errorCallBack("Unexpected status code: " + response.status);
        }
      })
      .catch((error: AxiosError) => {
          console.log('Error caught:', error);
          if (error.response?.status === 400) {
            _errorCallBack(error.response.data);
          } else if (error.response?.status === 404) {
              console.log(error.response.data);
            _errorCallBack(error.response.data);
          }else if (error.response?.status === 401) {
            localStorage.clear();
          } 
        });
  };
export const getZohoCustomer = (
  phone: string, 
  _successCallBack: (response: any) => void,
  _errorCallBack: (errMessage: any) => void
) => {
  const userDetailsFromStorage = JSON.parse(
    localStorage.getItem("userdetails") || "null"
  );
  
  const headers = {
    Authorization: `Bearer ${userDetailsFromStorage?.token}`, 
    "Content-Type": "application/json",
  };
  axios
    .get(
      `${global.api_url}/api/search_zoho_customer_by_phone?phone=${phone}`,
      {
        headers: headers,
      }
    )
    .then((response: AxiosResponse) => {
      if (response.status === 200 || response.status === 201) {
        _successCallBack(response.data);
      }
    })
    .catch((error: AxiosError) => {
      if (error.response?.status === 400) {
        _errorCallBack(error.response.data);
      } else if (error.response?.status === 401) {
        localStorage.clear();
      } else if (error.response?.status === 404) {
        _errorCallBack(error.response.data);
      } else {
        toast.error("Server Error");
      }
    });
};
export const getModels = (
  _successCallBack: (response: any) => void,
  _errorCallBack: (errMessage: any) => void,
  ) => {
    const userDetailsFromStorage = JSON.parse(localStorage.getItem("userdetails") || "null");
  const headers = {
    Authorization: `Bearer ${userDetailsFromStorage.token}`, 
  };
  axios
    .get(`${global.api_url}/api/list_models`, {
      headers: headers,
    })
    .then((response: AxiosResponse) => {
      if (response.status === 200 || response.status === 201) {
        _successCallBack(response.data);
      } else {
        _errorCallBack("Unexpected status code: " + response.status);
      }
    })
    .catch((error: AxiosError) => {
        console.log('Error caught:', error);
        if (error.response?.status === 400) {
          _errorCallBack(error.response.data);
        } else if (error.response?.status === 404) {
            console.log(error.response.data);
          _errorCallBack(error.response.data);
        }else if (error.response?.status === 401) {
          localStorage.clear();
        } 
      });
};
export const initiateBilling = (
  billed_to_clients_id: string,
  services: any[],
  _successCallBack: (response: any) => void,
  _errorCallBack: (errMessage: any) => void
) => {
  const userDetailsFromStorage = JSON.parse(
    localStorage.getItem("userdetails") || "null"
  );

  const headers = {
    Authorization: `Bearer ${userDetailsFromStorage?.token}`,
    "Content-Type": "application/json",
  };

  const payload = {
    billed_to_clients_id: billed_to_clients_id,
    services: services
  };

  axios
    .post(`${global.api_url}/api/initiate_billing`, payload, {
      headers: headers,
    })
    .then((response: AxiosResponse) => {
      if (response.status === 200 || response.status === 201) {
        _successCallBack(response.data);
      } else {
        _errorCallBack("Unexpected status code: " + response.status);
      }
    })
    .catch((error: AxiosError) => {
      console.log('Error caught:', error);
      if (error.response?.status === 400 || error.response?.status === 500) {
        _errorCallBack(error.response.data);
      } else if (error.response?.status === 401) {
        localStorage.clear();
      } else if (error.response?.status === 404) {
        console.log(error.response.data);
        _errorCallBack(error.response.data);
      } else {
        toast.error("Server Error");
        _errorCallBack(error.message);
      }
    });
};
export const addClient = (
  zoho_customer_id: string,
  name: string,
  email: string,
  phone: string,
  address: string,
  pincode: string,
  state: string,
  pan: string,
  gst: string,
  tan: string,
  cin: string,
  contact1_name: string,
  contact1_email: string,
  contact1_phone: string,
  contact1_designation: string,
  _successCallBack: (response: any) => void,
  _errorCallBack: (errMessage: any) => void
) => {
  const userDetailsFromStorage = JSON.parse(
    localStorage.getItem("userdetails") || "null"
  );

  const headers = {
    Authorization: `Bearer ${userDetailsFromStorage?.token}`,
    "Content-Type": "application/json",
  };
const rawPayload = {
    zoho_customer_id,
    name,
    email,
    phone,
    address,
    pincode,
    state,
    pan,
    gst,
    tan,
    cin,
    contact1_name,
    contact1_email,
    contact1_phone,
    contact1_designation,
  };
 const payload = Object.fromEntries(
    Object.entries(rawPayload).filter(([_, v]) =>  v !== "")
  );

  axios.post(`${global.api_url}/api/create_billed_to_client_from_zoho`, payload, { headers })
    .then((response: AxiosResponse) => {
      if (response.status === 200 || response.status === 201) {
        _successCallBack(response.data);
      } else {
        _errorCallBack("Unexpected status code: " + response.status);
      }
    })
    .catch((error: AxiosError) => {
      console.log("Error caught:", error);
      if (error.response?.status === 400 || error.response?.status === 409) {
        _errorCallBack(error.response.data);
      } else if (error.response?.status === 401) {
        localStorage.clear();
      } else if (error.response?.status === 404) {
        console.log(error.response.data);
        _errorCallBack(error.response.data);
      } else {
        toast.error("Server Error");
        _errorCallBack(error.message);
      }
    });
};

export const getCompanies = (
  per_page_records:any,
  page_number:any,
  phone: string | null, 
  _successCallBack: (response: any) => void,
  _errorCallBack: (errMessage: any) => void,
  ) => {
    const userDetailsFromStorage = JSON.parse(localStorage.getItem("userdetails") || "null");
  const headers = {
    Authorization: `Bearer ${userDetailsFromStorage.token}`, 
  };
  axios
    .get(`${global.api_url}/api/companies`, {
      params: {per_page_records, page_number,phone }, 
      headers: headers,
    })
    .then((response: AxiosResponse) => {
      if (response.status === 200 || response.status === 201) {
        _successCallBack(response.data);
      } else {
        _errorCallBack("Unexpected status code: " + response.status);
      }
    })
    .catch((error: AxiosError) => {
        console.log('Error caught:', error);
        if (error.response?.status === 400) {
          _errorCallBack(error.response.data);
        } else if (error.response?.status === 404) {
            console.log(error.response.data);
          _errorCallBack(error.response.data);
        }else if (error.response?.status === 401) {
          localStorage.clear();
        } 
      });
};
export const getZohoSync = (
  _successCallBack: (response: any) => void,
  _errorCallBack: (errMessage: any) => void,
  ) => {
    const userDetailsFromStorage = JSON.parse(localStorage.getItem("userdetails") || "null");
  const headers = {
    Authorization: `Bearer ${userDetailsFromStorage.token}`, 
  };
  axios
    .get(`${global.api_url}/api/sync_zoho_customers`, {
      headers: headers,
    })
    .then((response: AxiosResponse) => {
      if (response.status === 200 || response.status === 201) {
        _successCallBack(response.data);
      } else {
        _errorCallBack("Unexpected status code: " + response.status);
      }
    })
    .catch((error: AxiosError) => {
        console.log('Error caught:', error);
        if (error.response?.status === 400) {
          _errorCallBack(error.response.data);
        } else if (error.response?.status === 404) {
            console.log(error.response.data);
          _errorCallBack(error.response.data);
        }else if (error.response?.status === 401) {
          localStorage.clear();
        } 
      });
};